import { render, staticRenderFns } from "./loading2.vue?vue&type=template&id=39a3c32a&scoped=true&"
import script from "./loading2.vue?vue&type=script&lang=js&"
export * from "./loading2.vue?vue&type=script&lang=js&"
import style0 from "./loading2.vue?vue&type=style&index=0&id=39a3c32a&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a3c32a",
  null
  
)

export default component.exports